import { lazy, Suspense } from 'react';
import LazyLoading from '../../components/LazyLoading';

const LazySupportV2 = lazy(
  () => import(/* webpackChunkName: 'SupportV2' */ './index'),
);

export default function SupportV2() {
  return (
    <Suspense fallback={<LazyLoading />}>
      <LazySupportV2 />
    </Suspense>
  );
}
